export const BaseCheckoutBlockDtoDescriptions = {
  id: "Server-generated. Read-only.",
  variationId: "References the parent variation.",
  locationId:
    "Shopify checkout extensibility target location where the block renders.",
  blockType:
    "Discriminator for the checkout block type and its available variables/styles.",
  blockTemplate:
    "The template preset this block was created from, within its block type. Null on blocks saved before templates were persisted, which callers must treat as unknown rather than assuming a default.",
  name: "Display name for identifying this block in the dashboard.",
  cartTargeting: "The display rules based on what's in the users cart",
  displayConditions:
    "Optional cart-based conditions; the block renders only when the expression evaluates true against the current cart.",
  upsellProductRules:
    "Product selection and recommendation rules that determine which products to show in this upsell block.",
  agenticLogicPlacementId:
    "Agentic Logic placement this block evaluates through. Absent means the legacy rule engine serves it — clearing the mapping is the per-surface rollback.",
  agenticLogicRuleId:
    "WRITE-SIDE intent: the Agentic Logic rule this block should serve. The experience save upserts the placement and the (placement, variation) assignment from it and stamps `agenticLogicPlacementId`, so callers never assemble that pair themselves. Null detaches the block and returns it to the legacy engine. Reads echo the rule currently assigned.",
} as const;

export const UpsellCheckoutBlockDtoDescriptions = {
  ...BaseCheckoutBlockDtoDescriptions,
  blockType: "Identifies this as an upsell product recommendation block.",
  variables:
    "Configurable content for the upsell block (e.g., product selection, heading text, CTA label).",
  styles: "CSS styling overrides for the upsell block appearance.",
} as const;

export const TrustBadgeCheckoutBlockDtoDescriptions = {
  ...BaseCheckoutBlockDtoDescriptions,
  blockType: "Identifies this as a trust badge / social proof block.",
  variables:
    "Configurable content for the trust badge (e.g., badge images, guarantee text).",
  styles: "CSS styling overrides for the trust badge appearance.",
} as const;
